(function() {
    const tabs = document.querySelectorAll('.filter-tab');
    const cards = document.querySelectorAll('.recipe-card');
    const catRows = document.querySelectorAll('.cat-row');
    const count = document.getElementById('recipe-count');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const filter = tab.getAttribute('data-filter');

        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        let visible = 0;
        cards.forEach(card => {
          const category = card.getAttribute('data-category');
          if (filter === 'all' || filter === category) {
            card.style.display = '';
            visible++;
          } else {
            card.style.display = 'none';
          }
        });

        // Show category divider rows only in "all" view (or the matching one)
        catRows.forEach(row => {
          const cat = row.getAttribute('data-cat-row');
          row.style.display = (filter === 'all' || filter === cat) ? '' : 'none';
        });

        count.textContent = visible;
      });
    });
  })();